export default {
  name: 'hotline-number-with-icon',
  props: ['hotlineDetails', 'hotlineDestinationNumber', 'widgetStyle'],
  computed: {
    style() {
      return {
        fill: this.widgetStyle.main_color,
      };
    },
  },
};
